export const state = {
  debugOptions: {},
}

export const getters = {
  debugOptions(state) {
    return state.debugOptions
  },
}

export const mutations = {
  SET_DEBUG_OPTIONS(state, options) {
    state.debugOptions = options
  },
}
